export default {
    AD: 'Aldea',
    AE: 'Andén',
    AF: 'Afueras',
    AG: 'Agrupación',
    AH: 'Angosta',
    AL: 'Alameda',
    AN: 'Andador',
    AO: 'Arco',
    AP: 'Apartamento',
    AQ: 'Alquería',
    AR: 'Acera',
    AT: 'Ático',
    AU: 'Autovía',
    AV: 'Avenida',
    AY: 'Arroyo',
    AZ: 'Alto',
    BA: 'Barriada',
    BC: 'Barranco',
    BD: 'Bajada',
    BL: 'Bloque',
    BO: 'Barrio',
    BR: 'Barro',
    BU: 'Bulevar',
    C2: 'Calleja',
    CA: 'Casas',
    CB: 'Campo',
    CD: 'Corredera',
    CE: 'Carrera',
    CF: 'BOCORTijo',
    CG: 'Cuadra',
    CH: 'Chalet',
    CI: 'Carril',
    CJ: 'Callejón',
    CK: 'Canal',
    CL: 'Calle',
    CM: 'Camino',
    CÑ: 'Cañada',
    CN: 'Canto',
    CO: 'Colonia',
    CP: 'Cooperativa',
    CQ: 'Costanilla',
    CR: 'Carretera',
    CS: 'Caserío',
    CT: 'Cuesta',
    CU: 'Conjunto',
    CV: 'Circunvalación',
    CW: 'Convento',
    CX: 'Cerro',
    CY: 'Cantón',
    CZ: 'Calzada',
    DE: 'Dehesa',
    DS: 'Diseminado',
    EC: 'Escaleras',
    ED: 'Edificio',
    EN: 'Entrada',
    ET: 'Estación',
    EX: 'Extrarradio',
    FI: 'Finca',
    GA: 'Granja',
    GL: 'Glorieta',
    GR: 'Grupo',
    GV: 'Gran Vía',
    HU: 'Huerta',
    JA: 'Jardín',
    JS: 'Jardines',
    LA: 'Lago',
    LD: 'Ladera',
    LG: 'Lugar',
    LL: 'Llanura',
    LO: 'Loma',
    MA: 'Masia',
    MC: 'Mercado',
    MI: 'Mirador',
    ML: 'Muelle',
    MN: 'Municipio',
    MO: 'Monasterio',
    MT: 'Monte',
    MZ: 'Manzana',
    PA: 'Pabellón',
    PB: 'Poblado',
    PC: 'Placeta',
    PD: 'Partida',
    PE: 'Paraje',
    PF: 'Portal',
    PG: 'Polígono',
    PH: 'Pasillo',
    PI: 'Palacio',
    PJ: 'Pasaje',
    PK: 'Pinar',
    PL: 'Plazuela',
    PM: 'Puerta',
    PN: 'Pantano',
    PO: 'Plazoleta',
    PQ: 'Parque',
    PR: 'Prolongación',
    PS: 'Paseo',
    PT: 'Particular',
    PU: 'Puente',
    PV: 'Puerto',
    PY: 'Playa',
    PZ: 'Plaza',
    RB: 'Rambla',
    RD: 'Ronda',
    RI: 'Riera',
    RL: 'Ruela',
    RM: 'Ramal',
    RO: 'Ruero',
    RP: 'Rampa',
    RS: 'Residencial',
    RT: 'Rotonda',
    SC: 'Sector',
    SD: 'Subida',
    SN: 'Senda',
    TN: 'Transversal',
    TR: 'Travesía',
    TS: 'Trasera',
    TT: 'Torrente',
    TV: 'Travesera',
    UR: 'Urbanización',
    VA: 'Villa',
    VC: 'Vecindario',
    VG: 'Vega',
    VI: 'Vía',
    VL: 'Vial',
    VR: 'Vereda',
    ZN: 'Zona'
};
